<!--  -->
<template>
  <div class="onliner-mix" :class="{ 'has-toolbar-bottom': showBottom }">
    <div class="onliner-close pointer" @click="closeMix">
      <i class="el-icon-close"></i>
    </div>
    <video autoplay muted id="mix"></video>
    <ul
      class="onliner-layout"
      :style="{ width: `${videoWidth}px`, height: `${videoHeight}px` }"
      v-if="isSubSuccess"
    >
      <li
        v-for="item in layoutData.curLayout"
        :key="item.ptid"
        :style="{
          left: `${item.region.area.left * 100}%`,
          height: `${item.region.area.height * 100}%`,
          top: `${item.region.area.top * 100}%`,
          width: `${item.region.area.width * 100}%`,
        }"
      >
        <span class="onliner-name" v-if="partName(item.ptid)">{{
          partName(item.ptid)
        }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import Bus from "../../doc/bus";
import { mapState } from "vuex";
export default {
  created() {
    this.init();
  },
  data() {
    return {
      videoWidth: null,
      videoHeight: null,
      isSubSuccess: false,
      videoOriginWidth: null, //原尺寸
      videoOriginHeight: null,
    };
  },
  computed: {
    ...mapState("docInfo", ["showBottom"]),
    rtcClient() {
      return this.$store.getters.rtcClient;
    },
    layoutData() {
      return this.$store.getters.layoutData;
    },
    partName() {
      return (ptid) => {
        let partList = this.$store.getters.JoinedList;
        if (partList) {
          let partNameInfo = null;
          partNameInfo = partList.find((p) => {
            return parseInt(p.ptid) == ptid;
          });
          return partNameInfo && partNameInfo.name;
        }
      };
    },
    isShowMix() {
      return this.$store.getters.isShowMix;
    },
  },
  methods: {
    init() {
      if (document.getElementById("center-btm")) {
        document.getElementById("center-btm").onresize = () => {};
      }
      this.rtcClient.RTCRoom.subscribeMixStream().then((res) => {
        console.log(res);
        document.getElementById("mix").srcObject = res.mixedStream;
        this.$nextTick(() => {
          this.isSubSuccess = true;
        });
        document.getElementById("mix").oncanplay = () => {
          this.videoOriginWidth = document.getElementById("mix").videoWidth;
          this.videoOriginHeight = document.getElementById("mix").videoHeight;
          this.setLayoutSize();
        };
      });
      window.onresize = () => {
        this.setLayoutSize();
      };
      Bus.$on("closeSubMix", () => {
        this.closeMix();
      });
    },
    setLayoutSize() {
      console.log(document.getElementById("mix"));
      if (document.getElementById("mix")) {
        let clientWidth = document.getElementById("mix").clientWidth,
          clientHeight = document.getElementById("mix").clientHeight;
        let width = (clientHeight *  this.videoOriginWidth )  / this.videoOriginHeight;
        let height = (clientWidth *  this.videoOriginHeight ) / this.videoOriginWidth;
        this.videoWidth = width < clientWidth ? width : clientWidth;
        this.videoHeight = height < clientHeight ? height : clientHeight;
      }
    },
    closeMix() {
      this.isSubSuccess = false;
      this.rtcClient.RTCRoom.unsubscribeMixStream();
      this.$store.commit("SET_ISSHOWMIX", false);
    },
  },
};
</script>
<style lang='scss' scoped>
.onliner-mix {
  width: 100%;
  height: calc(100% - 30px);
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 1000;
  &.has-toolbar-bottom {
    height: calc(100% - 130px);
  }
  .onliner-close {
    position: absolute;
    right: 10px;
    top: 5px;
    z-index: 1;
    font-size: 20px;
    color: #fff;
    overflow: hidden;
    img {
      filter: drop-shadow(#fff 80px 0);
      -webkit-filter: drop-shadow(#fff 80px 0);
    }
  }
  video {
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
  }
  .onliner-layout {
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    margin: auto;
    li {
      position: absolute;
      .onliner-name {
        position: absolute;
        bottom: 10px;
        left: 5px;
        color: $white-color;
        background-color: rgba(0, 0, 0, 0.5);
        padding: 5px 10px;
        font-size: 12px;
        border-radius: 4px;
      }
    }
  }
}
</style>